module.exports = __webpack_public_path__ + "static/media/trash.ecf9e50f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/trash.svg
// module id = 1105
// module chunks = 1